import { render } from "./Credentials.vue?vue&type=template&id=8527b28e&scoped=true&ts=true"
import script from "./Credentials.vue?vue&type=script&lang=ts"
export * from "./Credentials.vue?vue&type=script&lang=ts"

import "./Credentials.vue?vue&type=style&index=0&id=8527b28e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8527b28e"]])

export default __exports__